import gql from "graphql-tag";
import API from "./client";
import { BlogListQuery } from "@/graphql/BlogList";
import { BlogsByCategory } from "@/graphql/BlogListByCategory";
import { BlogDetails } from "@/graphql/BlogDetails";
import { BlogListHeader } from "@/graphql/BlogListHeader";
import { UpdateBlogList } from "@/graphql/UpdatesBlogsList";
import { BlogSearch } from "@/graphql/BlogSearch";
import { BlogHeader } from "@/graphql/BlogHeader";
import { envConfig } from "@/envConfig";

export function BlogHeaderDetails() {
  return API.query({
    query: gql`
      ${BlogHeader()}
    `,
    variables: {
      status: "PUBLISHED",
      locale: envConfig.NEXT_PUBLIC_BLOGS_LOCALE,
    },
  });
}

export function BlogList(payload) {
  return API.query({
    query: gql`
      ${BlogListQuery()}
    `,
    variables: {
      pagination: {
        page: payload?.page,
        pageSize: payload?.pageSize,
      },
      filters: {
        category: {
          name: {
            containsi: payload?.categoryName || "",
          },
        },
        not: {
          slug: {
            eq: payload?.exceptSlug || "",
          },
        },
      },
      sort:
        payload?.filterBy === "Popular" ? ["priority:asc"] : ["createdAt:desc"],
      status: "PUBLISHED",
      locale: envConfig.NEXT_PUBLIC_BLOGS_LOCALE,
      blogsConnectionPagination2: {
        page: payload?.page,
        pageSize: payload?.pageSize,
      },
      blogsConnectionFilters2: {
        category: {
          name: {
            containsi: payload?.categoryName || "",
          },
        },
        not: {
          slug: {
            eq: payload?.exceptSlug || "",
          },
        },
      },
    },
  });
}

export function BlogListByCategory(payload) {
  return API.query({
    query: gql`
      ${BlogsByCategory()}
    `,
    variables: {
      filters: {
        slug: {
          containsi: payload?.categorySlug || "",
        },
      },
      status: "PUBLISHED",
      locale: envConfig.NEXT_PUBLIC_BLOGS_LOCALE,
    },
  });
}

export function BlogDetailsBySlug(payload) {
  return API.query({
    query: gql`
      ${BlogDetails()}
    `,
    variables: {
      filters: {
        slug: {
          eqi: payload?.slug,
        },
      },
      status: "PUBLISHED",
      locale: payload.locale,
    },
  });
}

export function BlogListForHeader() {
  return API.query({
    query: gql`
      ${BlogListHeader()}
    `,
    variables: {
      pagination: {
        page: 1,
        pageSize: 5,
      },
      filters: {
        category: {
          slug: {
            containsi: "",
          },
        },
        // "priority": {
        //   "between": [1, 5]
        // }
      },
      sort: ["priority:asc"],
      status: "PUBLISHED",
      locale: envConfig.NEXT_PUBLIC_BLOGS_LOCALE,
    },
  });
}

export function BlogListForUpdates(payload) {
  return API.query({
    query: gql`
      ${UpdateBlogList()}
    `,
    variables: {
      pagination: {
        page: payload?.page || 1,
        pageSize: payload?.pageSize || 100,
      },
      filters: {
        category: {
          slug: {
            containsi: "",
          },
        },
      },
      sort: ["createdAt:desc"],
      status: "PUBLISHED",
      blogsConnectionPagination2: {
        page: payload?.page || 1,
        pageSize: payload?.pageSize || 100,
      },
      locale: envConfig.NEXT_PUBLIC_BLOGS_LOCALE,
    },
  });
}

export function SearchBlogList(payload) {
  let filters = {};

  if (payload?.categoryName) {
    filters = {
      category: { name: { containsi: payload.categoryName } },
      or: [],
    };

    if (payload?.searchKey) {
      filters.or.push(
        { title: { containsi: payload.searchKey } },
        { author: { name: { containsi: payload.searchKey } } },
        { category: { name: { containsi: payload.searchKey } } }
      );
    }
  } else if (payload?.searchKey) {
    filters = {
      or: [
        { title: { containsi: payload.searchKey } },
        { author: { name: { containsi: payload.searchKey } } },
        { category: { name: { containsi: payload.searchKey } } },
      ],
    };
  }

  return API.query({
    query: gql`
      ${BlogSearch()}
    `,
    variables: {
      pagination: {
        page: 1,
        pageSize: 5,
      },
      sort: ["createdAt:desc"],
      status: "PUBLISHED",
      filters: Object.keys(filters).length ? filters : {},
      locale: envConfig.NEXT_PUBLIC_BLOGS_LOCALE,
    },
  });
}
